import { useRequest } from 'features/request/useRequest';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { isUniqueRatioWorkConditionsGql } from '../workOrderQueries';

interface IUseIsUniqueRatioWorkConditions {
    contractId: number;
    ratioRowId: number | null;
    workConditions: string;
}

export const useIsUniqueRatioWorkConditions = (props: IUseIsUniqueRatioWorkConditions) => {
    const dispatch = useDispatch();
    const { contractId, ratioRowId, workConditions } = props;
    const variables = useMemo(
        () => ({
            contractId,
            ratioRowId,
            workConditions,
        }),
        [contractId, ratioRowId, workConditions],
    );
    const [data, , , makeRequest] = useRequest({
        requestId: 'isUniqueRatioWorkConditions',
        query: isUniqueRatioWorkConditionsGql,
        variables,
        withEffect: false,
    });

    const debounceSetSearchValue = useDebounce(() => {
        if (workConditions) {
            dispatch(makeRequest(variables));
        }
    }, 500);

    useEffect(() => debounceSetSearchValue(), [debounceSetSearchValue, workConditions]);

    return {
        result: data ? data.uerIsUniqueRatioWorkConditions?.result : true,
        message: data?.uerIsUniqueRatioWorkConditions?.message,
    };
};
